import React, { createContext, useContext, useState, useCallback } from "react";
import { checkCredentials, DEMO_CLIENT } from "@/data/clientAreaDemo";

// Sessió de client de l'àrea (DEMO, sense backend: es perd en recarregar)
const ClientCtx = createContext(null);

export const ClientProvider = ({ children }) => {
  const [client, setClient] = useState(null);

  const login = useCallback((user, pass) => {
    if (checkCredentials(user, pass)) {
      setClient(DEMO_CLIENT);
      return true;
    }
    return false;
  }, []);

  const logout = useCallback(() => setClient(null), []);

  return (
    <ClientCtx.Provider value={{ client, login, logout }}>
      {children}
    </ClientCtx.Provider>
  );
};

export const useClient = () => {
  const ctx = useContext(ClientCtx);
  if (!ctx) throw new Error("useClient must be used within ClientProvider");
  return ctx;
};
